var zh_TW = {};
module['exports'] = zh_TW;
zh_TW.title = "Chinese (Taiwan)";
zh_TW.address = require("./address");
zh_TW.name = require("./name");
zh_TW.phone_number = require("./phone_number");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/zh_TW/index.js
// module id = 2230
// module chunks = 0